export const GET_PROGRAM_MUSICAL_FAMILIES = "GET_PROGRAM_MUSICAL_FAMILIES";
export const GET_PROGRAM_MUSICAL_FAMILY_BY_ID =
  "GET_PROGRAM_MUSICAL_FAMILY_BY_ID";
export const UPDATE_PROGRAM_MUSICAL_FAMILY = "UPDATE_PROGRAM_MUSICAL_FAMILY";
export const DELETE_PROGRAM_MUSICAL_FAMILY = "DELETE_PROGRAM_MUSICAL_FAMILY";
export const CREATE_PROGRAM_MUSICAL_FAMILY = "CREATE_PROGRAM_MUSICAL_FAMILY";
